module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dee5d4b0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/installation/ScanInstall.vue
// module id = 792
// module chunks = 0